import { initializeApp } from "firebase/app";
import { Analytics, getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FB_API_KEY,
    authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FB_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FB_APP_ID,
    measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID,
};

let analytics = null;

// Analytics is optional: without config (e.g. env vars missing on the host),
// skip it instead of crashing the page at import time.
if (typeof window !== "undefined" && firebaseConfig.measurementId) {
    try {
        analytics = getAnalytics(initializeApp(firebaseConfig));
    } catch (err) {
        console.warn("Firebase Analytics disabled:", err);
    }
}

export { analytics };

export function trackEvent(eventName, eventParams = {}) {
    if (analytics) {
        logEvent(analytics, eventName, eventParams);
    }
}